/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

/** Arguments for spoofing initial gps heading */
export interface SpoofInitialGpsHeadingActionArgs {
  heading: number;
  headingSigma: number;
}

export interface SpoofInitialGpsHeadingResultData {
}

export interface SpoofInitialGpsHeadingActionStateData {
}

function createBaseSpoofInitialGpsHeadingActionArgs(): SpoofInitialGpsHeadingActionArgs {
  return { heading: 0, headingSigma: 0 };
}

export const SpoofInitialGpsHeadingActionArgs = {
  encode(message: SpoofInitialGpsHeadingActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.heading !== 0) {
      writer.uint32(13).float(message.heading);
    }
    if (message.headingSigma !== 0) {
      writer.uint32(21).float(message.headingSigma);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofInitialGpsHeadingActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofInitialGpsHeadingActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 13) {
            break;
          }

          message.heading = reader.float();
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.headingSigma = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpoofInitialGpsHeadingActionArgs {
    return {
      heading: isSet(object.heading) ? globalThis.Number(object.heading) : 0,
      headingSigma: isSet(object.headingSigma) ? globalThis.Number(object.headingSigma) : 0,
    };
  },

  toJSON(message: SpoofInitialGpsHeadingActionArgs): unknown {
    const obj: any = {};
    if (message.heading !== 0) {
      obj.heading = message.heading;
    }
    if (message.headingSigma !== 0) {
      obj.headingSigma = message.headingSigma;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofInitialGpsHeadingActionArgs>, I>>(
    base?: I,
  ): SpoofInitialGpsHeadingActionArgs {
    return SpoofInitialGpsHeadingActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofInitialGpsHeadingActionArgs>, I>>(
    object: I,
  ): SpoofInitialGpsHeadingActionArgs {
    const message = createBaseSpoofInitialGpsHeadingActionArgs();
    message.heading = object.heading ?? 0;
    message.headingSigma = object.headingSigma ?? 0;
    return message;
  },
};

function createBaseSpoofInitialGpsHeadingResultData(): SpoofInitialGpsHeadingResultData {
  return {};
}

export const SpoofInitialGpsHeadingResultData = {
  encode(_: SpoofInitialGpsHeadingResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofInitialGpsHeadingResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofInitialGpsHeadingResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SpoofInitialGpsHeadingResultData {
    return {};
  },

  toJSON(_: SpoofInitialGpsHeadingResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofInitialGpsHeadingResultData>, I>>(
    base?: I,
  ): SpoofInitialGpsHeadingResultData {
    return SpoofInitialGpsHeadingResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofInitialGpsHeadingResultData>, I>>(
    _: I,
  ): SpoofInitialGpsHeadingResultData {
    const message = createBaseSpoofInitialGpsHeadingResultData();
    return message;
  },
};

function createBaseSpoofInitialGpsHeadingActionStateData(): SpoofInitialGpsHeadingActionStateData {
  return {};
}

export const SpoofInitialGpsHeadingActionStateData = {
  encode(_: SpoofInitialGpsHeadingActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofInitialGpsHeadingActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofInitialGpsHeadingActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SpoofInitialGpsHeadingActionStateData {
    return {};
  },

  toJSON(_: SpoofInitialGpsHeadingActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofInitialGpsHeadingActionStateData>, I>>(
    base?: I,
  ): SpoofInitialGpsHeadingActionStateData {
    return SpoofInitialGpsHeadingActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofInitialGpsHeadingActionStateData>, I>>(
    _: I,
  ): SpoofInitialGpsHeadingActionStateData {
    const message = createBaseSpoofInitialGpsHeadingActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
